import { render, staticRenderFns } from "./FooterProps.vue?vue&type=template&id=5f06430e&"
import script from "./FooterProps.vue?vue&type=script&lang=js&"
export * from "./FooterProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports